export const initialRestartFrequency = 10 * 1000; // 10 sec
export const maxRestartFrequency = 5 * 60 * 1000; // 5 min
